import { AssetId } from "./asset-id";
import { SiteId } from "./site-id";
import { TenantId } from "./tenant-id";

export type InstalledAsset = {
  tenant: TenantId;
  site: SiteId;
  asset: AssetId;
};

export const InstalledAsset = {
  eq: (a: InstalledAsset | null, b: InstalledAsset | null) =>
    a === b || (a !== null && b !== null && a.asset === b.asset && a.tenant === b.tenant && a.site === b.site),
};
